<div class="container">
  <h2>Customers</h2>

  <div class="toolbar">
    <div class="filter-group">
      <label>
        Status:
        <select [(ngModel)]="filterActive" (change)="loadCustomers()">
          <option [ngValue]="null">All</option>
          <option [ngValue]="true">Active</option>
          <option [ngValue]="false">Inactive</option>
        </select>
      </label>
    </div>
    <button class="btn-primary" (click)="toggleCreateForm()">
      {{ showCreateForm ? 'Cancel' : '+ Add Customer' }}
    </button>
  </div>

  <!-- Create / Edit form -->
  <div *ngIf="showCreateForm || editingCustomer" class="form-card">
    <h3>{{ editingCustomer ? 'Edit Customer' : 'New Customer' }}</h3>

    <form (ngSubmit)="saveCustomer()" #customerForm="ngForm">
      <div class="form-row">
        <div class="form-group">
          <label for="customerId">Customer ID <span class="required">*</span></label>
          <input
            id="customerId"
            type="text"
            [(ngModel)]="formData.customerId"
            name="customerId"
            required
            [disabled]="!!editingCustomer"
          />
        </div>
        <div class="form-group">
          <label for="customerName">Customer Name <span class="required">*</span></label>
          <input id="customerName" type="text" [(ngModel)]="formData.customerName" name="customerName" required />
        </div>

        <div class="form-group">
          <label for="customerType">Customer Type</label>
          <select
            id="customerType"
            [(ngModel)]="formData.customerType"
            name="customerType"
            class="form-control"
            (ngModelChange)="onTmsOrTypeChange()"
          >
            <option [ngValue]="null">— None —</option>
            <option *ngFor="let type of customerTypeOptions" [ngValue]="type">{{ type }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="tmsName">TMS Name <span class="required">*</span></label>
          <select
            id="tmsName"
            [(ngModel)]="formData.tmsName"
            name="tmsName"
            required
            class="form-control"
            (ngModelChange)="onTmsOrTypeChange()"
          >
            <option value="" disabled>Select TMS</option>
            <option *ngFor="let tms of tmsOptions" [value]="tms">{{ tms }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="syncFrequencyMinutes">Sync Frequency Minutes <span class="required">*</span></label>
          <input
            id="syncFrequencyMinutes"
            type="number"
            [(ngModel)]="formData.syncFrequencyMinutes"
            name="syncFrequencyMinutes"
            class="form-control"
            required
            min="0"
            (keypress)="allowOnlyNumbers($event)"
          />
        </div>

        <div class="form-group">
          <label for="orderRetentionDays">Order Retention Days <span class="required">*</span></label>
          <input
            id="orderRetentionDays"
            type="number"
            [(ngModel)]="formData.orderRetentionDays"
            name="orderRetentionDays"
            class="form-control"
            required
            min="0"
            (keypress)="allowOnlyNumbers($event)"
          />
        </div>
        <div class="form-group">
          <label for="tonuCode">Tonu Code</label>
          <input id="tonuCode" type="text" [(ngModel)]="formData.tonuCode" name="tonuCode" class="form-control" />
        </div>
        <div class="form-group">
          <label for="ianaTimezone">Time Zone</label>
          <select id="ianaTimezone" [(ngModel)]="formData.ianaTimezone" name="ianaTimezone" class="form-control">
            <option *ngFor="let tz of timezoneOptions" [value]="tz">{{ tz }}</option>
          </select>
          <span class="settings-hint">Customer's local time zone, used for dates sent to the TMS (for example DMS scan date).</span>
        </div>
      </div>

      <div class="form-group checkbox">
        <label>
          <input type="checkbox" [(ngModel)]="formData.enabled" name="enabled" />
          Enabled
        </label>
      </div>

      <div class="form-group checkbox">
        <label>
          <input type="checkbox" [(ngModel)]="formData.outboundEnabled" name="outboundEnabled" />
          Outbound Enabled
        </label>
      </div>

      <div class="collapsible">
        <button
          type="button"
          class="collapsible-header"
          (click)="credentialsExpanded = !credentialsExpanded"
          [attr.aria-expanded]="credentialsExpanded"
        >
          <span class="caret">{{ credentialsExpanded ? '▾' : '▸' }}</span>
          Credentials
          <span class="count-badge" *ngIf="getCurrentTmsKeys().length">{{ getCurrentTmsKeys().length }}</span>
        </button>

        <div class="collapsible-body" *ngIf="credentialsExpanded">
          <p *ngIf="!getCurrentTmsKeys().length" class="muted">Select a TMS to configure credentials.</p>
          <div *ngIf="getCurrentTmsKeys().length">
            <div class="form-row">
              <div class="col" *ngFor="let key of getCurrentTmsKeys()">
                <div class="form-group">
                  <label [for]="'credentials-' + key">
                    {{ key }} <span *ngIf="isDmsCredentialRequired(key)" class="required">*</span>
                  </label>

                  <!-- Template dropdown -->
                  <ng-container *ngIf="isTemplateDropdown(key)">
                    <select
                      [id]="'credentials-' + key"
                      [(ngModel)]="formData.credentials[key]"
                      [name]="'credentials.' + key"
                      class="form-control"
                      required
                      #tmplCtrl="ngModel"
                    >
                      <option value="">Select template</option>
                      <option *ngFor="let t of dmsTemplates" [value]="t.id">{{ t.name }}</option>
                    </select>
                    <span *ngIf="tmplCtrl.invalid && tmplCtrl.touched" class="field-error">{{ key }} is required.</span>
                  </ng-container>

                  <!-- API client dropdown -->
                  <ng-container *ngIf="isApiClientDropdown(key)">
                    <select
                      [id]="'credentials-' + key"
                      [(ngModel)]="formData.credentials[key]"
                      [name]="'credentials.' + key"
                      class="form-control"
                      required
                      #clientCtrl="ngModel"
                    >
                      <option value="">Select API client</option>
                      <option *ngFor="let c of dmsApiClients" [value]="c.id">{{ c.name }}</option>
                    </select>
                    <span *ngIf="clientCtrl.invalid && clientCtrl.touched" class="field-error"
                      >{{ key }} is required.</span
                    >
                  </ng-container>

                  <!-- Numeric field (text input so value is submitted as string) -->
                  <ng-container *ngIf="isNumericField(key)">
                    <input
                      [id]="'credentials-' + key"
                      type="text"
                      [(ngModel)]="formData.credentials[key]"
                      [name]="'credentials.' + key"
                      class="form-control"
                      required
                      pattern="[0-9]+"
                      (keypress)="allowOnlyNumbers($event)"
                      #numCtrl="ngModel"
                    />
                    <span *ngIf="numCtrl.invalid && numCtrl.touched" class="field-error">
                      <ng-container *ngIf="numCtrl.errors?.['required']">{{ key }} is required.</ng-container>
                      <ng-container *ngIf="numCtrl.errors?.['pattern']">Must be a numeric value.</ng-container>
                    </span>
                  </ng-container>

                  <!-- Transformer base URL (read-only, auto-populated) -->
                  <ng-container *ngIf="isTransformerBaseUrlField(key)">
                    <input
                      [id]="'credentials-' + key"
                      type="text"
                      [value]="transformerBaseUrl"
                      [name]="'credentials.' + key"
                      class="form-control"
                      disabled
                    />
                  </ng-container>

                  <!-- Regular text / URL field -->
                  <ng-container
                    *ngIf="
                      !isTemplateDropdown(key) &&
                      !isApiClientDropdown(key) &&
                      !isNumericField(key) &&
                      !isTransformerBaseUrlField(key)
                    "
                  >
                    <input
                      [id]="'credentials-' + key"
                      type="text"
                      [(ngModel)]="formData.credentials[key]"
                      [name]="'credentials.' + key"
                      class="form-control"
                      [required]="isDmsCredentialRequired(key)"
                      [pattern]="isDmsCredentialRequired(key) && isUrlField(key) ? urlPattern : ''"
                      [placeholder]="getCredentialPlaceholder(key)"
                      #credInput="ngModel"
                    />
                    <span *ngIf="credInput.invalid && credInput.touched" class="field-error">
                      <ng-container *ngIf="credInput.errors?.['required']">{{ key }} is required.</ng-container>
                      <ng-container *ngIf="credInput.errors?.['pattern']"
                        >Must be a valid URL (starting with http:// or https://).</ng-container
                      >
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapsible">
        <button
          type="button"
          class="collapsible-header"
          (click)="settingsExpanded = !settingsExpanded"
          [attr.aria-expanded]="settingsExpanded"
        >
          <span class="caret">{{ settingsExpanded ? '▾' : '▸' }}</span>
          Settings
          <span class="count-badge" *ngIf="getCurrentSettingsFields().length">{{
            getCurrentSettingsFields().length
          }}</span>
        </button>

        <div class="collapsible-body" *ngIf="settingsExpanded">
          <p *ngIf="!getCurrentSettingsFields().length" class="muted">
            No settings available for the selected TMS and customer type.
          </p>

          <div class="form-row" *ngIf="getCurrentSettingsFields().length">
            <div class="form-group" *ngFor="let f of getCurrentSettingsFields()">
              <label *ngIf="f.inputType !== 'checkbox'" [for]="'settings-' + f.key">{{ f.label }}</label>

              <label *ngIf="f.inputType === 'checkbox'" class="settings-checkbox-label">
                <input
                  type="checkbox"
                  [id]="'settings-' + f.key"
                  [checked]="isSettingChecked(f)"
                  (change)="setSettingChecked(f, $any($event.target).checked)"
                />
                {{ f.label }}
              </label>

              <select
                *ngIf="f.inputType === 'select'"
                [id]="'settings-' + f.key"
                [(ngModel)]="settings[f.key]"
                [name]="'settings.' + f.key"
                class="form-control"
              >
                <option value="">Select value</option>
                <option *ngFor="let opt of f.options" [value]="opt.value">{{ opt.label }}</option>
              </select>

              <textarea
                *ngIf="f.inputType === 'textarea'"
                [id]="'settings-' + f.key"
                [(ngModel)]="settings[f.key]"
                [name]="'settings.' + f.key"
                class="form-control"
                rows="4"
                [placeholder]="f.placeholder || ''"
              ></textarea>

              <input
                *ngIf="f.inputType === 'text'"
                [id]="'settings-' + f.key"
                type="text"
                [(ngModel)]="settings[f.key]"
                [name]="'settings.' + f.key"
                class="form-control"
                [placeholder]="f.placeholder || ''"
              />

              <ng-container *ngIf="f.inputType === 'integer'">
                <input
                  [id]="'settings-' + f.key"
                  type="text"
                  [(ngModel)]="settings[f.key]"
                  [name]="'settings.' + f.key"
                  class="form-control"
                  pattern="[0-9]*"
                  [placeholder]="f.placeholder || ''"
                  (keypress)="allowOnlyNumbers($event)"
                  #intCtrl="ngModel"
                />
                <span *ngIf="intCtrl.invalid && intCtrl.touched" class="field-error">Must be a whole number.</span>
              </ng-container>

              <span *ngIf="f.description" class="settings-hint">{{ f.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="collapsible" *ngIf="showDocTypeMapping">
        <button
          type="button"
          class="collapsible-header"
          (click)="docMappingExpanded = !docMappingExpanded"
          [attr.aria-expanded]="docMappingExpanded"
        >
          <span class="caret">{{ docMappingExpanded ? '▾' : '▸' }}</span>
          Export Document Mapping
          <span class="count-badge" *ngIf="docTypeMappingsList.length">{{ docTypeMappingsList.length }}</span>
        </button>

        <div class="collapsible-body" *ngIf="docMappingExpanded">
          <p class="section-hint">
            Map a WFAI source document type to the customer's target type. Target type is free text and differs per
            customer. Use the <b>Default (all other types)</b> source for a catch-all mapping.
          </p>

          <div class="doc-mapping-table" *ngIf="docTypeMappingsList.length">
            <div class="doc-mapping-thead">
              <span>Source Document Type</span>
              <span>Target Type</span>
              <span></span>
            </div>

            <div class="doc-mapping-row" *ngFor="let m of docTypeMappingsList; let i = index">
              <div class="cell">
                <select
                  [id]="'docmap-source-' + i"
                  [(ngModel)]="m.source"
                  [name]="'docMapSource-' + i"
                  class="form-control"
                  required
                  #srcCtrl="ngModel"
                >
                  <option value="" disabled>Select source type</option>
                  <option [value]="defaultDocTypeSource" [disabled]="isSourceTaken(defaultDocTypeSource, i)">
                    Default (all other types)
                  </option>
                  <option *ngFor="let dt of wfaiDocTypes" [value]="dt.id" [disabled]="isSourceTaken(dt.id, i)">
                    {{ dt.id }} - {{ dt.name }}
                  </option>
                </select>
                <span *ngIf="srcCtrl.invalid && srcCtrl.touched" class="field-error">Source type is required.</span>
              </div>

              <div class="cell">
                <input
                  [id]="'docmap-target-' + i"
                  type="text"
                  [(ngModel)]="m.target"
                  [name]="'docMapTarget-' + i"
                  class="form-control"
                  required
                  placeholder="Customer target type"
                  #tgtCtrl="ngModel"
                />
                <span *ngIf="tgtCtrl.invalid && tgtCtrl.touched" class="field-error">Target type is required.</span>
              </div>

              <button
                type="button"
                class="icon-remove"
                (click)="removeDocTypeMapping(i)"
                title="Remove mapping"
                aria-label="Remove mapping"
              >
                ✕
              </button>
            </div>
          </div>

          <p *ngIf="!docTypeMappingsList.length" class="muted">No document mappings configured.</p>

          <button type="button" class="btn-small btn-info doc-mapping-add" (click)="addDocTypeMapping()">
            + Add Mapping
          </button>
        </div>
      </div>

      <div class="form-actions">
        <button class="btn-primary" type="submit" [disabled]="!customerForm.form.valid || creating || updating">
          <span *ngIf="creating || updating" class="spinner"></span>
          {{ creating ? 'Creating...' : updating ? 'Saving...' : editingCustomer ? 'Save Changes' : 'Create Customer' }}
        </button>

        <button type="button" class="btn-secondary" (click)="cancelEdit()">Cancel</button>
      </div>
    </form>
  </div>

  <div *ngIf="error" class="alert alert-error">{{ error }}</div>
  <div *ngIf="success" class="alert alert-success">{{ success }}</div>

  <!-- Table -->
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>TMS</th>
          <th>Status</th>
          <th>Sync (min)</th>
          <th>Retention (days)</th>
          <th>Last Sync</th>
          <th>Tonu Code</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let c of customers">
          <td>
            <strong>{{ c.customerName }}</strong>
          </td>
          <td>{{ c.customerType || '—' }}</td>
          <td>{{ c.tmsName }}</td>

          <td>
            <span class="badge" [class.badge-active]="c.enabled" [class.badge-inactive]="!c.enabled">
              {{ c.enabled ? 'Active' : 'Inactive' }}
            </span>
          </td>

          <td>{{ c.syncFrequencyMinutes || '—' }}</td>
          <td>{{ c.orderRetentionDays || '—' }}</td>

          <td>{{ c.lastSyncTime | date: 'medium' }}</td>
          <td>{{ c.tonuCode || '—' }}</td>

          <td class="actions">
            <button class="btn-small btn-info" (click)="startEdit(c)">Edit</button>

            <button class="btn-small btn-info" (click)="toggleStatus(c)" [disabled]="togglingStatus[c.customerId]">
              <span *ngIf="togglingStatus[c.customerId]" class="spinner"></span>
              <span *ngIf="!togglingStatus[c.customerId]">
                {{ c.enabled ? 'Deactivate' : 'Activate' }}
              </span>
            </button>

            <button
              class="btn-small btn-danger"
              (click)="deleteCustomer(c.customerId)"
              [disabled]="deleting[c.customerId]"
            >
              <span *ngIf="deleting[c.customerId]" class="spinner"></span>
              <span *ngIf="!deleting[c.customerId]">Delete</span>
            </button>
          </td>
        </tr>

        <tr *ngIf="customers.length === 0">
          <td colspan="9" class="no-data">No customers found.</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="isInitialLoading" class="fullscreen-loader">
      <div class="loader-spinner"></div>
    </div>
  </div>
</div>
